<div class="card flex-grow mb-0 product-creation-wizard" style="margin: 0 15px 15px; background-color: transparent">
  <div class="content-area-wrapper" style="height: 87vh; gap: 16px">
    <div class="card" style="width: 400px">
      <app-layout-steps-client
        [steps]="steps"
        [currentStep]="currentStep"
        (goBack)="retour()"
        (stepSelected)="onTimelineStepSelected($event)">
      </app-layout-steps-client>
    </div>

    <div class="card content-right custom-scroll" style="overflow: auto; flex: 1">
      <div class="content-wrapper p-0 content-right-r">
        <div class="card-body">
          <div class="wizard-content">
            <div *ngIf="currentStep === 0" class="step-form">
              <h4 class="mb-2">Entreprise</h4>
              <p class="text-muted mb-3">
                Confirmez l'entreprise ERP liée à cet accès logiciel caisse.
              </p>
              <div class="form-section rounded p-3">
                <div class="mb-2">
                  <label class="form-label">Nom de l'entreprise</label>
                  <input class="form-control" [value]="enterpriseName || '—'" readonly />
                </div>
                <div class="mb-0">
                  <label class="form-label">Code station</label>
                  <input class="form-control" [value]="code_station" readonly />
                  <small class="text-muted" *ngIf="erpStationId">
                    Identifiant station ERP : id {{ erpStationId }} → {{ code_station }}
                  </small>
                </div>
              </div>
            </div>

            <div *ngIf="currentStep === 1" class="step-form">
              <h4 class="mb-2">{{ hasExistingAcces ? 'Connexion logiciel caisse' : 'Identifiants logiciel caisse' }}</h4>
              <p class="text-muted mb-3" *ngIf="hasExistingAcces">
                Un accès existe déjà pour cette station ({{ email }}). Saisissez le mot de passe pour vous connecter au back caisse.
              </p>
              <p class="text-muted mb-3" *ngIf="!hasExistingAcces">
                Ces identifiants serviront à connecter l'ERP au back logiciel caisse.
              </p>
              <div class="alert alert-warning py-2" *ngIf="hasExistingAcces && passwordLegacyHash">
                Le mot de passe ERP est en ancien format. Saisissez le mot de passe logiciel caisse pour vous connecter.
              </div>
              <div class="form-section rounded p-3">
                <div class="mb-2">
                  <label class="form-label">Email</label>
                  <input
                    class="form-control"
                    type="email"
                    [(ngModel)]="email"
                    name="email"
                    [readonly]="hasExistingAcces"
                    [class.is-invalid]="showEmailError" />
                </div>
                <div class="mb-2">
                  <label class="form-label">Mot de passe</label>
                  <input
                    class="form-control"
                    type="password"
                    [(ngModel)]="password"
                    name="password"
                    [class.is-invalid]="showPasswordError" />
                </div>
                <div class="mb-0">
                  <label class="form-label">Confirmer le mot de passe</label>
                  <input
                    class="form-control"
                    type="password"
                    [(ngModel)]="confirmPassword"
                    name="confirmPassword"
                    [class.is-invalid]="showPasswordError" />
                </div>
              </div>
            </div>

            <div *ngIf="currentStep === 2" class="step-form">
              <h4 class="mb-2">Validation</h4>
              <p class="text-muted mb-3" *ngIf="hasExistingAcces">
                Connexion au logiciel caisse avec l'accès ERP existant.
              </p>
              <p class="text-muted mb-3" *ngIf="!hasExistingAcces">
                Un compte sera créé sur le logiciel caisse et enregistré dans l'ERP.
              </p>
              <div class="form-section rounded p-3">
                <p class="mb-1"><strong>Entreprise :</strong> {{ enterpriseName || '—' }}</p>
                <p class="mb-1"><strong>Code station :</strong> {{ code_station }}</p>
                <p class="mb-1" *ngIf="erpStationId"><strong>Id station ERP :</strong> {{ erpStationId }}</p>
                <p class="mb-0"><strong>Email :</strong> {{ email }}</p>
              </div>
            </div>

            <div class="d-flex justify-content-end mt-3 gap-2">
              <button type="button" class="btn btn-outline-secondary" (click)="retour()" [disabled]="isSubmitting">
                Retour
              </button>
              <button type="button" class="btn btn-primary" (click)="nextStep()" [disabled]="isSubmitting">
                <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-1"></span>
                {{ currentStep < 2 ? 'Suivant' : (hasExistingAcces ? 'Se connecter' : 'Créer et connecter') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
